import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getListOfAssets = (projectCode, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-lists-code/${projectCode}?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

export const searchListOfAssets = (projectCode, request, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-lists/${projectCode}/search/?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}
